import { render, staticRenderFns } from "./ChannelAssign.vue?vue&type=template&id=0a3e0122&scoped=true"
import script from "./ChannelAssign.vue?vue&type=script&lang=js"
export * from "./ChannelAssign.vue?vue&type=script&lang=js"
import style0 from "./ChannelAssign.vue?vue&type=style&index=0&id=0a3e0122&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e0122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3e0122')) {
      api.createRecord('0a3e0122', component.options)
    } else {
      api.reload('0a3e0122', component.options)
    }
    module.hot.accept("./ChannelAssign.vue?vue&type=template&id=0a3e0122&scoped=true", function () {
      api.rerender('0a3e0122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/ChannelAssign.vue"
export default component.exports